export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  ACCEPTANCE: "acceptance",
  UNION: "union",
  REHEARSAL: "rehearsal",
  DELIVERED: "delivered"
};

export const TESTING_ENVIRONMENTS = [
  ENVIRONMENTS.DEVELOPMENT,
  ENVIRONMENTS.ACCEPTANCE
];
